import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import about from "../views/AboutView.vue";
import contact from "../views/ContactView.vue";
import Portfolio from "../views/PortfolioView.vue";
import gallery from "../views/GalleryView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: about,
  },
  {
    path: "/Portfolio",
    name: "Portfolio",
    component: Portfolio,
  },
  {
    path: "/gallery",
    name: "gallery",
    component: gallery,
  },
  {
    path: "/contact",
    name: "contact",
    component: contact,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
